import React, { useState, useEffect, useContext } from "react";
import { useFirebase } from '../context/firebaseContext';
import { useAuth } from '../context/authContext';
import { PlatformContext } from '../context/PlatformContext';
import { doc, getDoc } from 'firebase/firestore';

export default function FullScreenImage() {
    const { db } = useFirebase();
    const { user: currentUser, loading: authLoading } = useAuth();
    const { platform } = useContext(PlatformContext);
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const isMobile = platform === 'mobileWeb' || platform === 'mobileApp';

    useEffect(() => {
        const fetchUserData = async () => {
            if (authLoading) {
                return; // Wait for auth to finish loading
            }

            if (!currentUser || !currentUser.uid) {
                setLoading(false);
                return;
            }

            setLoading(true);
            try {
                const userDocRef = doc(db, 'users', currentUser.uid);
                const userDoc = await getDoc(userDocRef);

                if (!userDoc.exists()) {
                    setError('User not found');
                } else {
                    setUserData(userDoc.data());
                    setError(null); // Clear any previous errors
                }
            } catch (err) {
                setError('Error fetching user data');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, [currentUser, db, authLoading]);

    if (authLoading || loading) {
        return null;
    }

    if (error) {
        return (
            <div className="is-flex is-align-items-center is-justify-content-center vh-100">
                <div>Error: {error}</div>
            </div>
        );
    }

    const welcomeMessage = currentUser && userData
        ? `Welcome, ${userData.username}`
        : "Welcome";

    return (
        <div
            className="full-screen-image-container hundredminnavdesktop margin-top-0"
            style={{
                backgroundImage: isMobile ? 'none' : `url('/img/saturnwallpaper.jpg')`,
            }}
        >
            <h1
                className="has-text-weight-bold transparentgrey has-text-weight-bold is-size-1 has-text-warning vcentered-title"
                style={{
                    backgroundColor: "#191919",
                    padding: "1rem",
                }}
            >
                {welcomeMessage}
            </h1>
        </div>
    );
}
